import styled from "styled-components";
import { mobileSize } from "Themes/Metrics";

export const ProfileContainer = styled.div`
    background-color: white;
    background-image: url(${props => props.image});
    background-position: center; 
    background-size: cover;
    padding: 0px 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    border: solid 2px lightgray;
    border-radius: 5px;
    margin: 5;  
    @media ${mobileSize.large} {
        display: none;
    }
    height: 40px;
    width: 40px;

`;

const styles = {
    text: {
        color: "white"
    },
    container: {
        border: "solid 2px white",
    },
    imgContainer: {
        backgroundColor: "white",
        width: "50px"
    },

    image: {
        height: "30px"
    },
    profileContainer: {
        backgroundColor: "white",
        padding: "0 5px 0 5px",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        border: "solid 2px lightgray",
        borderRadius: "5px",
        margin: 5,
    },
    profileImage: {
        padding: "1px",
        height: "30px",
        width: "30px",
        cursor: "pointer",
        borderRadius: "5px"
    },
    dropdownItem: {
        "&:hover": {
            backgroundColor: "lightgray"
        },
        cursor: "pointer",
        padding: 10
    }

}

export default styles;